var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubmittable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 5.143 11.043 L 5.143 19.449 L 9.134 21.485 L 13.125 23.521 L 16.724 21.473 C 20.619 19.331, 20.643 19.293, 20.643 14.275 C 20.643 9.717, 20.371 9.054, 17.250 6.002 C 15.357 4.168, 13.588 2.7, 13.236 2.7 C 12.884 2.7, 12.571 4.114, 12.571 5.825 C 12.571 8.541, 12.859 9, 14.786 9 C 16.904 9, 17.063 9.285, 17.063 13.366 C 17.063 18.631, 14.939 20.635, 11.117 18.897 C 9.173 18.022, 8.982 17.395, 8.982 11.638 C 8.982 6.678, 9.263 5.4, 10.286 5.4 C 11.021 5.4, 11.629 4.811, 11.629 4.05 C 11.629 3.105, 10.699 2.7, 8.536 2.7 L 5.143 2.7 L 5.143 11.043",
    fill: "#fc5c2c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmittable);
export default __webpack_public_path__ + "static/media/submittable.981ec8fd2106cb1bde68d90db92a44e6.svg";
export { ForwardRef as ReactComponent };